import { useEffect, useState } from "react";
import ApiDataBase from "server";

// Reads the rate as the api's parseWage does (utils/minimumWage.js), so the
// wizard blocks exactly the rates the api would flag below the minimum wage.
export const parseHourlyRate = (value) => {
    if (value === null || value === undefined) return null;
    const normalized = String(value).replace(",", ".").trim();
    if (!normalized) return null;
    const rate = parseFloat(normalized);
    return Number.isFinite(rate) ? rate : null;
};

export const formatHourlyRate = (rate) =>
    new Intl.NumberFormat("fr-FR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(rate);

// An unknown minimum wage never blocks: the api still flags the template.
export const isBelowMinimumWage = (templateData, minimumWage) => {
    if (templateData?.isIndexedToMinimumWage || minimumWage == null) {
        return false;
    }
    const rate = parseHourlyRate(templateData?.salary);
    return rate !== null && rate < minimumWage;
};

// One request per page session, shared by the rate step and the wizard footer.
// A failed request is dropped so the next mount retries.
let minimumWageRequest = null;
let loadedMinimumWage = null;

const loadMinimumWage = () => {
    if (!minimumWageRequest) {
        const request = new Promise((resolve, reject) =>
            ApiDataBase.getMinimumWage(resolve, reject)
        ).then((data) => {
            loadedMinimumWage = parseHourlyRate(data?.hourly?.gross);
            return loadedMinimumWage;
        });
        request.catch((err) => {
            console.warn(err);
            if (minimumWageRequest === request) minimumWageRequest = null;
        });
        minimumWageRequest = request;
    }
    return minimumWageRequest;
};

export const useMinimumWage = () => {
    const [minimumWage, setMinimumWage] = useState(loadedMinimumWage);

    useEffect(() => {
        let isMounted = true;
        loadMinimumWage().then(
            (value) => {
                if (isMounted) setMinimumWage(value);
            },
            () => {}
        );
        return () => {
            isMounted = false;
        };
    }, []);

    return minimumWage;
};
